import React from 'react'
import Layout from '../components/layout'
import Slider from '../components/slider'

import ImgA from '../assets/4A.png'
import ImgB from '../assets/5A.jpg'
import ImgC from '../assets/6A.jpg'
import ImgD from '../assets/7A.jpg'



import styled from 'styled-components'


const Div = styled.div`

.about-gallery {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    max-width: 900px;
    margin: 65px auto 0;
}

.about-gallery-item {
    position: relative;
    overflow: hidden;

    aspect-ratio: 1 / 1;

    border-radius: 12px;
}

.about-gallery-item img {
    width: 100%;
    height: 100%;

    display: block;

    object-fit: cover;

    transition: transform 0.5s ease;
}

.about-gallery-item:hover img {
    transform: scale(1.04);
}

.about-section {
    padding: 70px 0 60px;
    background: #ffffff;
}


/* =========================
   HEADER
========================= */

.about-header {
    max-width: 850px;
    margin: 0 auto 45px;
}

.about-eyebrow {
    display: block;
    margin-bottom: 8px;

    font-size: 13px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;

    color: #E85A20;
}

.about-title {
    margin: 0;

    font-size: 42px;
    line-height: 1.15;
    font-weight: 700;

    color: #102B50;
}

.about-line {
    width: 55px;
    height: 4px;

    margin: 18px auto 20px;

    background: #E85A20;
    border-radius: 10px;
}

.about-intro {
    max-width: 680px;
    margin: 0 auto;

    font-size: 18px;
    line-height: 1.7;

    color: #687586;
}


/* =========================
   TEXTO
========================= */

.about-text {
    max-width: 1000px;
    margin: 0 auto 55px;

    font-size: 16px;
    line-height: 1.75;

    color: #26384d;
}

.about-text p {
    margin-bottom: 20px;
}


/* =========================
   CARDS
========================= */

.about-features {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    margin-top: 20px;
}


.about-card {
    position: relative;

    padding: 35px 32px 32px;

    background: #ffffff;

    border: 1px solid #e8ebef;
    border-radius: 12px;

    box-shadow: 0 8px 25px rgba(20, 40, 60, 0.08);

    overflow: hidden;

    transition:
        transform 0.25s ease,
        box-shadow 0.25s ease;
}


.about-card:hover {
    transform: translateY(-5px);

    box-shadow: 0 14px 32px rgba(20, 40, 60, 0.13);
}


/* línea naranja superior */

.about-card::before {
    content: "";

    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 4px;

    background: #E85A20;
}


/* numeración */

.about-card-number {
    position: absolute;

    top: 22px;
    right: 25px;

    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1px;

    color: #cfd5dc;
}


/* icono */

.about-card-icon {
    width: 54px;
    height: 54px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 22px;

    border-radius: 50%;

    background: #fff1eb;

    color: #E85A20;

    font-size: 28px;
    font-weight: 700;
}


.about-card h3 {
    margin: 0;

    font-size: 27px;
    font-weight: 700;

    color: #102B50;
}


.about-card-line {
    width: 35px;
    height: 3px;

    margin: 13px 0 18px;

    background: #E85A20;
    border-radius: 5px;
}


.about-card p {
    margin: 0;

    font-size: 15px;
    line-height: 1.7;

    color: #536273;
}


/* =========================
   SLIDER
========================= */

.about-slider {
    margin-top: 65px;
}


/* =========================
   RESPONSIVE
========================= */

@media (max-width: 991px) {

    .about-section {
        padding: 55px 0 45px;
    }

    .about-features {
        grid-template-columns: 1fr;
        gap: 18px;
    }

    .about-card {
        padding: 30px;
    }

}


@media (max-width: 576px) {

    .about-title {
        font-size: 34px;
    }

    .about-intro {
        font-size: 16px;
    }

    .about-text {
        font-size: 15px;
        line-height: 1.7;
    }

    .about-card h3 {
        font-size: 24px;
    }

}

`

export default function About() {
    return (
        <Layout>
            <Div>
                <section className="about-section">

                    <div className="container-xl">

                        {/* Título */}
                        <div className="about-header text-center">
                            <span className="about-eyebrow">
                                EDIFICAR SEGUROS
                            </span>

                            <h2 className="about-title">
                                Quiénes somos
                            </h2>

                            <div className="about-line"></div>

                            <p className="about-intro">
                                Brindamos seguridad y respaldo para acompañar
                                a nuestros clientes en la protección de su patrimonio.
                            </p>
                        </div>


                        {/* Información institucional */}
                        <div className="about-text">

                            <p>
                                Somos una compañía conformada íntegramente por
                                capitales nacionales. Brindamos seguridad en las
                                personas mediante una atención de excelencia,
                                asegurando el profesionalismo de los que componen
                                la compañía, y acompañando a los clientes en la
                                preservación del patrimonio desde hace más de una década.
                            </p>

                            <p>
                                Sabemos que la familia es lo más importante, por
                                ello en Edificar Seguros contamos con una cobertura
                                personalizada para proteger eso que tanto cuidás,
                                ofreciendo el respaldo económico que la misma
                                necesita ante cualquier imprevisto.
                            </p>

                            <p>
                                Nos diferenciamos en el mercado por contar con una
                                estructura operativa dinámica, ágil y eficiente,
                                con una alta solidez patrimonial y financiera,
                                brindando un servicio de atención personalizada
                                acorde a los requerimientos de los asegurados.
                            </p>

                        </div>


                        {/* Misión / Visión / Valores */}
                        <div className="about-features">

                            <div className="about-card">
                                <div className="about-card-number">01</div>

                                <div className="about-card-icon">
                                    <span>◎</span>
                                </div>

                                <h3>Misión</h3>

                                <div className="about-card-line"></div>

                                <p>
                                    Queremos brindar seguridad a las personas
                                    mediante una atención de excelencia,
                                    asegurando el profesionalismo de los que
                                    componen la compañía, acompañando a nuestros
                                    clientes en la preservación del patrimonio.
                                </p>
                            </div>


                            <div className="about-card">
                                <div className="about-card-number">02</div>

                                <div className="about-card-icon">
                                    <span>↗</span>
                                </div>

                                <h3>Visión</h3>

                                <div className="about-card-line"></div>

                                <p>
                                    Ampliar nuestras propuestas de servicios
                                    acorde a las necesidades del cliente.
                                </p>
                            </div>


                            <div className="about-card">
                                <div className="about-card-number">03</div>

                                <div className="about-card-icon">
                                    <span>✦</span>
                                </div>

                                <h3>Valores</h3>

                                <div className="about-card-line"></div>

                                <p>
                                    Honestidad, confidencialidad, confianza,
                                    esfuerzo, proactividad y creatividad.
                                </p>
                            </div>

                        </div>

                        <div className="about-gallery">
                            <div className="about-gallery-item">
                                <img src={ImgA} alt="Edificar Seguros" />
                            </div>

                            <div className="about-gallery-item">
                                <img src={ImgB} alt="Edificar Seguros" />
                            </div>

                            <div className="about-gallery-item">
                                <img src={ImgC} alt="Edificar Seguros" />
                            </div>

                            <div className="about-gallery-item">
                                <img src={ImgD} alt="Edificar Seguros" />
                            </div>
                        </div>


                        {/* Slider */}
                        {/* <div className="about-slider">
                            <Slider
                                ImgA={ImgA}
                                ImgB={ImgB}
                                ImgC={ImgC}
                            />
                        </div> */}

                    </div>

                </section>
            </Div>
        </Layout>
    );
}


// export default function About()  {

//     return(
//         <Layout>
//             <Div className="container-xl p-0" >

//                 <div className="px-2 text-lg-left text-center">
//                     <h3 className="pt-3 text-company"><b>Quiénes Somos?</b></h3>
//                     <p>Somos una compañía conformada íntegramente por capitales nacionales. Brindamos seguridad en las personas mediante una atención de excelencia, asegurando el profesionalismo de los que componen la compañía, y acompañando a los clientes en la preservación del patrimonio desde hace más de una década. Sabemos que la familia es lo más importante, por ello en Edificar Seguros contamos con una cobertura personalizada para proteger eso que tanto cuidas, ofreciendo el respaldo económico que la misma necesita ante cualquier imprevisto.</p>
//                     <p>Nos diferenciamos en el mercado por contar con una estructura operativa dinámica, ágil y eficiente, con una alta solidez patrimonial y financiera, brindando un servicio de atención personalizada acorde a los requerimientos de los asegurados.</p>

//                     <div className="features">
//                         <div>
//                             <h3>Misión</h3>
//                             <p>Queremos brindar seguridad a las personas mediante una atención de excelencia, asegurando el profesionalismo de los que componen la compañía acompañando a nuestros clientes en la preservación del patrimonio</p>
//                         </div>
//                         <div>
//                             <h3>Visión</h3>
//                             <p>Ampliar nuestras propuestas de servicios acorde a las necesidades del cliente.</p>
//                         </div>
//                         <div>
//                             <h3>Valores</h3>
//                             <p>Honestidad, confidencialidad, confianza, esfuerzo, proactividad, creatividad</p>
//                         </div>
//                     </div>
//                 </div>
                

//                 <div className="pt-4 px-0">
//                     <Slider  ImgA={ImgA} ImgB={ImgB} ImgC={ImgC} />
//                 </div>

//             </Div>
//         </Layout>

//     )

// }